package dev.wyns.ventrova.platform

/** Small persistent settings store (SharedPreferences, NSUserDefaults, localStorage). */
interface KeyValueStore {
    fun getBoolean(key: String, default: Boolean = false): Boolean
    fun putBoolean(key: String, value: Boolean)
    fun getStringSet(key: String): Set<String>
    fun putStringSet(key: String, value: Set<String>)
}

/** Non-persistent store, for previews and tests. */
class InMemoryKeyValueStore : KeyValueStore {
    private val values = mutableMapOf<String, Any>()

    override fun getBoolean(key: String, default: Boolean) = values[key] as? Boolean ?: default
    override fun putBoolean(key: String, value: Boolean) {
        values[key] = value
    }

    @Suppress("UNCHECKED_CAST")
    override fun getStringSet(key: String) = values[key] as? Set<String> ?: emptySet()
    override fun putStringSet(key: String, value: Set<String>) {
        values[key] = value
    }
}
